import React, { KeyboardEvent } from 'react'

import style from './ResultsStatusBar.module.css'

import { useAppDispatch, useAppSelector } from 'common/hooks'
import {
  ResultType,
  selectCurrentTaskNumber,
  selectResults,
  setCurrentTaskNumber,
} from 'features/exam'

export const ResultsStatusBar = () => {
  const dispatch = useAppDispatch()
  const currentTaskNumber = useAppSelector(selectCurrentTaskNumber)
  const results = useAppSelector(selectResults)

  const getItemClassName = (result: ResultType, index: number) => {
    const currentClassName = index === currentTaskNumber ? style['item--current'] : ''
    let isCorrectClassName = ''

    if (result?.status === true) {
      isCorrectClassName = style['item--correct']
    } else if (result?.status === false) {
      isCorrectClassName = style['item--incorrect']
    }

    return `${currentClassName} ${isCorrectClassName} ${style.indicator}`
  }

  const indicatorClickHandler = (num: number) => {
    if (currentTaskNumber !== num) {
      dispatch(setCurrentTaskNumber(num))
    }
  }

  const indicatorKeyDownHandler = (e: KeyboardEvent<HTMLAnchorElement>, index: number) => {
    // it's for keyboard accessibility (' ' is using for skipping question on document)
    if (e.key === ' ') {
      indicatorClickHandler(index)
    }
  }

  return (
    <div className={style.box}>
      <p className={style.text}>
        {currentTaskNumber + 1} из {results.length}
      </p>
      <ul className={style.bar}>
        {results.map((result, index) => (
          <li key={index}>
            <a
              tabIndex={0}
              className={style.link}
              onClick={() => indicatorClickHandler(index)}
              aria-label={`Перейти к вопросу ${index + 1}`}
              onKeyDown={e => indicatorKeyDownHandler(e, index)}
            >
              <div className={getItemClassName(result, index)}></div>
            </a>
          </li>
        ))}
      </ul>
    </div>
  )
}
